import { render, staticRenderFns } from "./ApplySuccess.vue?vue&type=template&id=57bb6857&scoped=true&"
import script from "./ApplySuccess.vue?vue&type=script&lang=js&"
export * from "./ApplySuccess.vue?vue&type=script&lang=js&"
import style0 from "./ApplySuccess.vue?vue&type=style&index=0&id=57bb6857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bb6857",
  null
  
)

/* custom blocks */
import block0 from "./ApplySuccess.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./ApplySuccess.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
